import React from "react";
import "./beats.css";
import "./components/components.css";
import { Container } from "react-bootstrap";
import { Route, Switch, useRouteMatch } from "react-router-dom/cjs/react-router-dom.min";
import BeatsHeader from "./header";
import MusicPlayer from "./components/MusicPlayer";
import { AudioProvider } from "./context/AudioContext";

// Import all the component pages
import BeatsHome from "./components/BeatsHome";
import AiStemsSeparator from "./components/AiStemsSeparator";
import AutoMastering from "./components/AutoMastering";
import MusicIdentification from "./components/MusicIdentification";
import AiVoiceChanger from "./components/AiVoiceChanger";
import MyFiles from "./components/MyFiles";
import ActiveFile from "./components/ActiveFile";
import BeatsChords from "./components/BeatsChords";
import LyricsAi from "./components/LyricsAi";
import BeatsHelp from "./components/BeatsHelp";
import MyLibrary from "./components/MyLibrary";
import Workspace from "./components/Workspace";
import ProjectPage from "./components/ProjectPage";

const Beats = () => {
  let { path } = useRouteMatch();

  return (
    <AudioProvider>
      <BeatsHeader />
        <Container fluid className="beats-content">
          <Switch>
            <Route exact path={`${path}`} component={BeatsHome} />
            <Route path={`${path}/my-library`} component={MyLibrary} />
            <Route path={`${path}/workspace`} component={Workspace} />
            <Route path={`${path}/project/:projectId`} component={ProjectPage} />
            <Route path={`${path}/ai-stems-separator`} component={AiStemsSeparator} />
            <Route path={`${path}/auto-mastering`} component={AutoMastering} />
            <Route path={`${path}/music-identification`} component={MusicIdentification} />
            <Route path={`${path}/ai-voice-changer`} component={AiVoiceChanger} />
            <Route path={`${path}/my-projects`} component={MyFiles} />
            <Route path={`${path}/beats-chords`} component={BeatsChords} />
            <Route path={`${path}/lyrics-ai`} component={LyricsAi} />
            <Route path={`${path}/help`} component={BeatsHelp} />
          </Switch>
          <MusicPlayer /> 
        </Container>
    </AudioProvider>
  );
};

export default Beats;
